// Loads xlsx-js-style, the community fork of sheetjs that writes per-cell styles (the
// upstream xlsx package reads but doesn't write them). Dynamic import keeps the ~150KB out
// of the initial bundle.
//
// The package ships as UMD (`dist/xlsx.min.js`) - Vite's CJS-to-ESM interop sometimes nests
// the real module under `.default`, sometimes hoists named exports up too. Resolve both
// shapes so a call site doesn't quietly no-op when the top-level namespace is missing
// `.utils` / `.writeFile`.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadXlsxStyle = async (): Promise<any> => {
  const imported = await import("xlsx-js-style");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const XLSXStyle: any =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (imported as any).utils && (imported as any).writeFile
      ? imported
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (imported as any).default;
  if (!XLSXStyle || !XLSXStyle.utils || !XLSXStyle.writeFile) {
    throw new Error(
      "xlsx-js-style loaded but the expected utils / writeFile entrypoints are missing",
    );
  }
  return XLSXStyle;
};
